import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {useShowError} from '@hooks/useShowError/useShowError'
import {getUserStyleApi, updateUserStyleApi} from '@containers/accountStyle/api/api'
import {IUserStyle, MenuColor} from '@containers/accountStyle/types'

export const QUERY_KEY_USER_STYLE = 'user-style'

export const useUserStyleQuery = () => {
	return useQuery({
		queryFn: () => getUserStyleApi(),
		queryKey: [QUERY_KEY_USER_STYLE],
		staleTime: 1000 * 60 * 30,
	})
}

export const useUpdateUserStyleMutation = () => {
	const queryClient = useQueryClient()
	const {onShowError} = useShowError()
	const queryKey = [QUERY_KEY_USER_STYLE]

	return useMutation({
		mutationFn: (menuColor: MenuColor | null) => updateUserStyleApi(menuColor, onShowError),
		onMutate: async (menuColor) => {
			await queryClient.cancelQueries({queryKey})
			const previous = queryClient.getQueryData<IUserStyle>(queryKey)
			if (previous) {
				queryClient.setQueryData<IUserStyle>(queryKey, {...previous, menuColor})
			}
			return {previous}
		},
		onError: (_error, _menuColor, context) => {
			queryClient.setQueryData(queryKey, context?.previous)
		},
	})
}
